import React from 'react'
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { TitoAcceptCashout } from "../../../actions/terminal";

const CashIn = ({ data, closePopup }) => {
  const dispatch = useDispatch();

  const cashIn = () => {
    dispatch(TitoAcceptCashout({ docId: data.barcode, amount: data.amount }));
    closePopup();
  }

  return null // template is commented
}

CashIn.propTypes = {
  dara: PropTypes.object,
  closePopup: PropTypes.func,
  terminalBalance: PropTypes.number,
  depositMode: PropTypes.number,
};

export default CashIn
